var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.00017 15.0315C11.8835 15.0315 15.0316 11.8834 15.0316 8.00005C15.0316 4.1167 11.8835 0.968628 8.00017 0.968628C4.11682 0.968628 0.96875 4.1167 0.96875 8.00005C0.96875 11.8834 4.11682 15.0315 8.00017 15.0315Z","stroke":"#26C653","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.36914 8.33825L7.09981 9.71381L10.63 6.28638","stroke":"#26C653","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Check.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
